module.exports = __webpack_public_path__ + "static/media/fire.a4beeea0.gif";